module.exports = __webpack_public_path__ + "img/LOGO_3CAG.84d972c0.jpg";